export default {
	methods: {
		createMaterialItemsFromAssemblyItems(assemblyItems,assemblyQty,numSegments,linearQty) {
			let materials = [], labourActions = []

			assemblyItems.forEach(item => {

				if (item.material_id > 0) {
					if (item.location == "Single") 
						item.Material.qty = +item.qty * +assemblyQty
					else if (item.location == "Line") 
						item.Material.qty = +item.qty * +linearQty * +assemblyQty
					else if (item.location == "Segment") 
						item.Material.qty = +item.qty * +numSegments * +assemblyQty
					
					materials.push(item.Material)
				}
				else if (item.action_id > 0) {
					labourActions.push(item.LabourAction)
				}
			})

			return {
				materials,
				labourActions
			}
		}
	}
}